import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_component_Icon, {
    src: _ctx.iconSource,
    style: _normalizeStyle([_ctx.expand ? 'transform: rotate(180deg);' : '', {"transition":"transform 0.2s"}])
  }, null, 8, ["src", "style"]))
}